"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "routes", {
    enumerable: true,
    get: function() {
        return routes;
    }
});
const _types = require("./types");
const routes = (0, _types.buildRoutes)({
    adminPropertyEdit: {
        path: `/backoffice/properties/:propertyId`
    },
    adminAccountCreate: {
        path: `/admin/accounts/create`
    },
    tasks: {
        path: `/admin/tasks`
    },
    csvImports: {
        path: `/admin/csv-imports/:importType`
    }
});

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3JvdXRpbmcvYmFja29mZmljZS50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBidWlsZFJvdXRlcyB9IGZyb20gXCIuL3R5cGVzXCI7XG5cbmV4cG9ydCBjb25zdCByb3V0ZXMgPSBidWlsZFJvdXRlcyh7XG4gIGFkbWluUHJvcGVydHlFZGl0OiB7XG4gICAgcGF0aDogYC9iYWNrb2ZmaWNlL3Byb3BlcnRpZXMvOnByb3BlcnR5SWRgLFxuICB9LFxuICBhZG1pbkFjY291bnRDcmVhdGU6IHtcbiAgICBwYXRoOiBgL2FkbWluL2FjY291bnRzL2NyZWF0ZWAsXG4gIH0sXG4gIHRhc2tzOiB7XG4gICAgcGF0aDogYC9hZG1pbi90YXNrc2AsXG4gIH0sXG4gIGNzdkltcG9ydHM6IHtcbiAgICBwYXRoOiBgL2FkbWluL2Nzdi1pbXBvcnRzLzppbXBvcnRUeXBlYCxcbiAgfSxcbn0pO1xuIl0sIm5hbWVzIjpbInJvdXRlcyIsImJ1aWxkUm91dGVzIiwiYWRtaW5Qcm9wZXJ0eUVkaXQiLCJwYXRoIiwiYWRtaW5BY2NvdW50Q3JlYXRlIiwidGFza3MiLCJjc3ZJbXBvcnRzIl0sIm1hcHBpbmdzIjoiOzs7OytCQUVhQTs7O2VBQUFBOzs7dUJBRmU7QUFFckIsTUFBTUEsU0FBU0MsSUFBQUEsa0JBQVcsRUFBQztJQUNoQ0MsbUJBQW1CO1FBQ2pCQyxNQUFNLENBQUMsa0NBQWtDLENBQUM7SUFDNUM7SUFDQUMsb0JBQW9CO1FBQ2xCRCxNQUFNLENBQUMsc0JBQXNCLENBQUM7SUFDaEM7SUFDQUUsT0FBTztRQUNMRixNQUFNLENBQUMsWUFBWSxDQUFDO0lBQ3RCO0lBQ0FHLFlBQVk7UUFDVkgsTUFBTSxDQUFDLDhCQUE4QixDQUFDO0lBQ3hDO0FBQ0YifQ==